@if (showBanner()) {
  <div class="legal-gate-banner">
    <div class="legal-gate-banner__content">
      <ng-icon class="legal-gate-banner__icon" name="iconoirPrivacyPolicy" size="20" />
      <span class="legal-gate-banner__text">
        Une mise à jour de nos <strong>{{ bannerDocumentsLabel() }}</strong> nécessite votre accord
        @if (graceDeadline(); as deadline) {
          avant le <strong>{{ deadline | date:'d MMMM y' }}</strong>.
        } @else {
          .
        }
      </span>
    </div>
    <div class="legal-gate-banner__actions">
      <app-btn
        [config]="{ type: 'filled', color: 'coffee', size: 'small' }"
        (click)="openModal()"
      >
        Lire et accepter
      </app-btn>
      <button type="button" class="legal-gate-banner__dismiss" (click)="dismissBanner()">
        Plus tard
      </button>
    </div>
  </div>
}

@if (showOrganisationBanner()) {
  <div class="legal-gate-org-banner">
    <div class="legal-gate-org-banner__content">
      <ng-icon class="legal-gate-org-banner__icon" name="iconoirPrivacyPolicy" size="20" />
      <span class="legal-gate-org-banner__text">
        @if (organisationPendingDocuments().length === 1) {
          @if (organisationLabel(); as orgLabel) {
            <strong>{{ orgLabel }}</strong> doit signer
          } @else {
            Votre organisation doit signer
          }
          <strong>{{ documentLabels[organisationPendingDocuments()[0].type] }}</strong> pour rester en règle.
        } @else {
          @if (organisationLabel(); as orgLabel) {
            <strong>{{ orgLabel }}</strong> doit signer plusieurs documents
          } @else {
            Votre organisation doit signer plusieurs documents
          }
          pour rester en règle :
          @for (doc of organisationPendingDocuments(); track doc.version.id; let last = $last) {
            <strong>{{ documentLabels[doc.type] }}</strong>{{ last ? '.' : ', ' }}
          }
        }
      </span>
    </div>
    <div class="legal-gate-org-banner__actions">
      <a
        [routerLink]="documentLinks[organisationPendingDocuments()[0].type].path"
        class="legal-gate-org-banner__cta"
      >
        Signer maintenant
      </a>
      <button type="button" class="legal-gate-org-banner__dismiss" (click)="dismissOrganisationBanner()">
        Plus tard
      </button>
    </div>
  </div>
}

@if (showModal()) {
  <div class="legal-gate-overlay" (click)="onBackdropClick($event)">
    <div class="legal-gate-modal" role="dialog" aria-modal="true" aria-labelledby="legal-gate-modal-title">
      <header class="legal-gate-modal__header">
        <h2 class="legal-gate-modal__title" id="legal-gate-modal-title">Mise à jour de nos documents légaux</h2>
        @if (!isBlocking()) {
          <button type="button" class="legal-gate-modal__close" (click)="closeModal()" aria-label="Fermer">
            <ng-icon name="iconoirXmark" size="18" />
          </button>
        }
      </header>

      <p class="legal-gate-modal__intro">
        @if (isBlocking()) {
          Le délai pour accepter ces mises à jour est dépassé. Merci de les relire et de les
          accepter pour continuer à utiliser Mokah+.
        } @else if (graceDeadline(); as deadline) {
          Merci de relire et d'accepter les documents suivants avant le {{ deadline | date:'d MMMM y' }}.
        } @else {
          Merci de relire et d'accepter les documents suivants.
        }
      </p>

      <div class="legal-gate-modal__body">
        @for (doc of pendingDocuments(); track doc.version.id) {
          <section class="legal-gate-document">
            <header class="legal-gate-document__header">
              <div class="legal-gate-document__heading">
                <h3 class="legal-gate-document__title">{{ documentLabels[doc.type] }}</h3>
                <a
                  [href]="documentLinks[doc.type].path"
                  target="_blank"
                  rel="noopener"
                  class="legal-gate-document__link"
                >
                  Ouvrir dans une page
                </a>
              </div>
              @if (doc.version.change_summary) {
                <p class="legal-gate-document__summary">{{ doc.version.change_summary }}</p>
              }
            </header>

            <div class="legal-gate-document__content" [innerHTML]="doc.renderedHtml"></div>

            <label class="legal-gate-document__checkbox">
              <input
                type="checkbox"
                [checked]="isChecked(doc.version.id)"
                [disabled]="submitting()"
                (change)="toggleChecked(doc.version.id)"
              />
              <span>J'ai lu et j'accepte {{ documentLabels[doc.type] }}</span>
            </label>
          </section>
        }
      </div>

      @if (error(); as errorMessage) {
        <div class="legal-gate-modal__error">
          <ng-icon name="iconoirWarningTriangle" size="16" />
          <span>{{ errorMessage }}</span>
        </div>
      }

      <footer class="legal-gate-modal__footer">
        <app-btn
          [config]="{ type: 'filled', color: 'coffee', disabled: !allChecked(), loading: submitting() }"
          (click)="acceptAll()"
        >
          Accepter et continuer
        </app-btn>
      </footer>
    </div>
  </div>
}
